import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-year-to-date-payments',
  templateUrl: './vb-payments-year-to-date-payments.component.html',
  styleUrls: ['./vb-payments-year-to-date-payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsYearToDatePaymentsComponent {
  @Input() yearToDatePayments = 0;
}
